import React, { Component } from "react";
import "./App.css";
import PmDriverReconciliation from "./PmDriverReconciliation";
//import Shipments from "./Shipments";
import axios from "axios";
import { host_url, domain_name } from "./app-config";
import localForage from "localforage";
import cookie from "react-cookies";
import string from "prop-types";
import queryString from "query-string";
import AppData from "./Context/AppData";
//import { withRouter } from "react-router-dom";
import withAppData from "../src/HOC/withAppData";
import Loader from "../src/Loaders/Loading";
import {
  _findArray,
  _uniqueArray,
  _isSameDate,
  _cloneObject,
  _sortArray,
  _delayAsyncFunction,
  db,
} from "./Utils/helpers";
//import ShipmentOrderProcessing from './Component/WareHouse/ShipmentOrderProcessing'
import ModalLoading from "./Loaders/ModalLoading";
import Loadable from "react-loadable";
import "./Styles/app.scss";
import OrderProcessing from "./Component/WareHouse/OMSOrderProcessing"
import BusinessHome from "./Component/BusinessHome";

const AlertModal = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'alertmodal' */ "./Resources/AlertModal"),
  loading: ModalLoading,
  delay: 100,
  timeout: 60000,
});


class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDownloadMenu: false,
      loadAlertModal: false,
      loadSwitchModal: false,
      isAppInstalled: true,
      pageTitle: "",
      HeaderData: "",
      walletAmount: { Amount: 0, AmountFormated: "0", WalletExists: 0 },
      BusinessOwnerIdsWithNames: [],
      showOfflineStrip: false,
      pushNotification:
        "Notification" in window ? window.Notification.permission : "",
      SessionData: "",
      networkStatus: "",
      jsonHeader: "",
      hideInstallPrompt: "hide-prompt",
      services: [],
      gmbLocationId: "",
      currencyCode: "",
      leads: {
        filter: 0,
        unAcceptedLead: 0,
        marketCount: 0,
        unAcceptedMarket: [],
        marketParams: "",
      },
      AlertModal: {
        showAlertModal: false,
        showSuccess: false,
        showError: false,
        alertModalHeader: "",
        alertModalSubheader: "",
        autoClose: false,
      },
      enableSteps: false,
      tourType: "",
      termsProps: "",
      loggedOut: false,
      rtUrl: "",
      subscriptionStatus: {},
      clevertapHeader: {
        headers: {
          "content-type": "application/json",
          source: "PWA",
        },
      },
      googleLocationId: "",
      isGoogleSyncing: false,
      googleBusinessDetails: "",
      facebookDetails: "",
      isFbSynced: false,
      isWebsiteSynced: false,
      isUserInvite: false,
      allBusinesses: [],
      offlineNotif: null,
      showUpdateNotification: false,
      syncedOfflineData: false,
      syncDataError: false,
      showOfflineSwitchToggle: false,
      fetchingOfflineData: false,
      showSidebar: false,
      permissions: { modules: [], subModules: [], features: [] },
      appVersion: {},
      pushMessages: [],
      updatePageData: {},
      syncRetries: 0,
      activatedBusinessSettings: [],
      contactTypes: [],
      connectionStatus: { downlink: 0, rtt: 0, effectiveType: "" },
      pendingRequests: [],
      showMemoryError: false,
      showUpdateBrowserPrompt: false,
      storage: {},
      customReports: [],
      customDashboards: [],
      disableSendbird: false,
      pendingAppUpdateVersion: cookie.load("pendingAppVersion"),
      apiActive: false,
      businessId: 0,
      orderId: 0,
      processtype: 2,
      sourceId: 0,
      reconcilliation: 0,
      shipment: 0,
      history: 0,
      userId: 0,
      urlPath: "",
      urlDataNew:[]
    };
    this.getHeaderData = this.getHeaderData.bind(this);
    //this.checkHeaderData = this.checkHeaderData.bind(this);
    //this.closeUpdate = this.closeUpdate.bind(this);
    //this.updateHeaders = this.updateHeaders.bind(this);
    //this.showAlertModal = this.showAlertModal.bind(this);
  }

  componentDidMount() {
    var lengthOfUrl=window.location.href.indexOf("?");
    if(lengthOfUrl>1)
    {
      var urldata=window.location.href;
      var data = urldata.split("&");
      this.setState({urlPath:window.location.href,
        urlDataNew:data
      })
    }
    
    console.log("did mount called");

    this.checkAutoLogin();
  }
  async checkHeaderData(message) {
    // debugger;
    try {
      let headerData = await localForage.getItem("headerData");
      if (headerData) {
        this.setState({ walletAmount: headerData.walletAmount });
        this.setState({
          BusinessOwnerIdsWithNames: _sortArray(
            headerData.BusinessOwnerIdsWithNames,
            "BusinessId"
          ),
        });
        this.setState({ HeaderData: headerData }, () => {
          this.setPermissions();
          if (message !== undefined) {
            if (message === "showalert") {
              this.getHeaderData("showalert");
            } else {
              this.getHeaderData(message);
            }
          } else {
            this.getHeaderData();
          }
        });
      } else {
        if (message !== undefined) {
          if (message === "showalert") {
            this.getHeaderData("showalert");
          } else {
            this.getHeaderData(message);
          }
        } else {
          this.getHeaderData();
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  autoLogin(ck, businessId) {
    cookie.remove("vcSessionData", { path: "/", domain: `${domain_name}` });
    cookie.remove("sessionId", { path: "/", domain: `${domain_name}` });
    cookie.remove("vcHeaderData", { path: "/" });
    cookie.remove("activeBusinessId", { path: "/", domain: `${domain_name}` });
    localForage.removeItem("headerData");
    localForage.removeItem("sessionData");
    axios
      .post(
        `${host_url}user/Autologin`,
        { ClaimBizKey: ck },
        this.state.clevertapHeader
      )
      .then((response) => {
        if (response.data.StatusCode === 1) {
          let businessDetails = response.data.Result;
          this.setState({userId: businessDetails.UserId})
          this.login(businessDetails, businessId);
          if (businessDetails) {
            this.getVirtualAccountDetailsPromise(businessDetails.UserId).then(
              (virtualAccountResponse) => {
                businessDetails = {
                  ...businessDetails,
                  virtualAccountNumber:
                    virtualAccountResponse.data.Result.AccountNumber,
                  virtualAccountBankName:
                    virtualAccountResponse.data.Result.BankName,
                };
                //this.login(businessDetails, businessId);
              }
            );
            //this.login(businessDetails, businessId);
          }
        }
      })
      .catch((error) => {
        console.log("Autologin Error: -" + error);
        this.props.context.showAlert(error.message, "error");
        //this.logOut();
      });
  }

  getHeaderData(message) {
    //this.getCityAndStates();
    axios
      .get(
        `${host_url}AccountDetails/GetBusinessHeaderData`,
        this.state.jsonHeader,
      )
      .then(response => {
        if (response.data.StatusCode === 1) {
          // this.loadSubscription();
          // this.getBusinessSettings();
          // this.getContactTypes();
          localForage.setItem("headerData", response.data.Result).catch(err => {
            console.log(err);
          });
          localStorage.setItem(
            "countryData",
            JSON.stringify(response.data.Result.walletAmount.countryData),
          );
          this.setState({
            walletAmount: response.data.Result.walletAmount,
          });
          this.setState({
            BusinessOwnerIdsWithNames: _sortArray(
              response.data.Result.BusinessOwnerIdsWithNames,
              "BusinessId",
            ),
          });
          this.setState({ HeaderData: response.data.Result }, () => {
            this.setPermissions();
            if (message !== undefined) {
              if (message === "showalert") {
                // let alertModalDetails = {
                // 	showAlertModal: true,
                // 	showSuccess: true,
                // 	showError: false,
                // 	alertModalHeader: `You have successfully switched to ${this.state.HeaderData.BusinessName}`,
                // 	alertModalSubheader: "",
                // 	autoClose: true,
                // };
                let homePage = window.location.origin + "/#/";
                window.location.href = homePage;
                //this.showAlertModal(alertModalDetails);
                /**
                 * clear meeting state in indexed db just in case
                 * it's not cleared and reload other tabs
                 */
                //this.clearMeetingData({ reload: true });
                /**
                 * fetch offline data for the new business
                 */
                //this.setState({ fetchingOfflineData: 2 });
              }
            }
          });
        }
      })
  }

  checkAutoLogin() {
    if (window.location.href.includes("verifyandlogin")) {
      //this.loadMouseFlow();
      window.sessionStorage.clear();
      this.windowLocalStorageClear(0);
      localForage
        .iterate((value, key) => {
          if (
            ![
              "settings",
              "appVersion",
              "surveyPhoneNumbers",
              "cachedContacts",
            ].includes(key)
          ) {
            localForage
              .removeItem(key)
              .then()
              .catch((err) => {
                console.log(err);
              });
          }
        })
        .then(() => { })
        .catch((err) => {
          console.log(err);
        });
      if (window.location.href) {
        const urlString = window.location.href;
        const urlQuery = urlString.substring(
          urlString.indexOf("?"),
          urlString.length
        );
        const urlParams = queryString.parse(urlQuery);
        const claimKey = urlParams.claimKey;
        const businessId = urlParams.businessId;
        const isMarket = urlParams.isMarket;
        const sourceId = urlParams.sourceId;
        const shipment = urlParams.shipment;
        const reconcilliation = urlParams.reco;
        const order = urlParams.orderId;
        const history = urlParams.history;
        console.log("history", history)
        const processtype = urlParams.processtype;
        this.setState({ businessId: businessId });
        this.setState({ sourceId: sourceId });
        this.setState({ reconcilliation: reconcilliation });
        this.setState({ shipment: shipment });
        this.setState({ orderId: order });
        this.setState({ history: history });
        this.setState({ processtype: processtype });
        if (isMarket) {
          localForage.setItem("isMarket", true).catch((err) => {
            console.log(err);
          });
        }
        if (claimKey) {
          this.autoLogin(claimKey, businessId);
        } else {
          //this.checkLoginStatus();
          //this.checkAppData();
        }
        if (sourceId) {
          this.autoLogin(sourceId, businessId);
        } else { }
      }
    } else {
      if (window.location.href) {
        const urlString = window.location.href;
        const urlQuery = urlString.substring(
          urlString.indexOf("?"),
          urlString.length
        );
        const urlParams = queryString.parse(urlQuery);
        const isMarket = urlParams.isMarket;
        if (isMarket) {
          localForage.setItem("isMarket", true).catch((err) => {
            console.log(err);
          });
        }
      }
      //this.checkLoginStatus();
      //this.checkAppData();
    }
  }

  login(bus, busid) {
    const tempLocation = window.location.href;
    if (tempLocation.includes("newpassword")) {
      window.location.href = window.location.origin + "/#/";
    }

    let sessionData = {};
    let buslists = bus.BusinessesList;
    this.setState({
      allBusinesses: bus.BusinessesList,
    });
    let businessNames = [];
    let businessIds = [];
    let businessCountries = [];

    if (buslists.length > 0) {
      buslists.forEach((business) => {
        businessNames.push(business.BusinessName);
        businessIds.push(business.BusinessId);
        businessCountries.push(business.countrycode);
      });

      if (busid) {
        window.location.href = window.location.href.split("?")[0];
        let tempIds = businessIds;
        let tempNames = businessNames;
        let tempCountries = businessCountries;

        const idPosition = tempIds.indexOf(Number(busid));
        if (idPosition > -1) {
          const tempId = tempIds[idPosition];
          const tempName = tempNames[idPosition];
          const tempCountry = tempCountries[idPosition];
          tempIds.splice(idPosition, 1);
          tempIds.unshift(tempId);
          tempNames.splice(idPosition, 1);
          tempNames.unshift(tempName);
          tempCountries.splice(idPosition, 1);
          tempCountries.unshift(tempCountry);

          sessionData.VCUserBusinessIds = tempIds;
          sessionData.VCUserBusinessNames = tempNames;
          sessionData.VCCountry = tempCountries;
        } else {
          sessionData.VCUserBusinessIds = businessIds;
          sessionData.VCUserBusinessNames = businessNames;
          sessionData.VCCountry = businessCountries;
        }
      } else {
        sessionData.VCUserBusinessIds = businessIds;
        sessionData.VCUserBusinessNames = businessNames;
        sessionData.VCCountry = businessCountries;
      }
      sessionData.VCUserContentID = bus.UserId;
      sessionData.VCLoginID = bus.EmailId;
      sessionData.VCUserName = bus.ContactName;
      sessionData.VCUserPhoto = bus.Photo;
      sessionData.VCUserPhone = bus.Phone;
      sessionData.VCUserToken = bus.JsonToken;
      sessionData.isAgent = bus.IsAgent;
      sessionData.isFinance = bus.IsFinance;
      sessionData.virtualAccountNumber = bus.AccountNumber;
      sessionData.virtualAccountBankName = bus.BankName;
      const expires = new Date();
      expires.setDate(new Date().getDate() + 180);

      cookie.save("vcLoginToken", sessionData.VCUserToken, {
        domain: `${domain_name}`,
        expires,
        path: "/",
      });

      cookie.save("activeUserId", bus.UserId, {
        domain: `${domain_name}`,
        expires,
        path: "/",
      });

      let jsonHeader = {
        headers: {
          "content-type": "application/json",
          source: "PWA",
          Token: bus.JsonToken,
          BusinessId: businessIds[0],
          UserId: bus.UserId,
          countrycode: sessionData.VCCountry[0],
        },
      };
      //localStorage.setItem("jsonHeader", JSON.stringify(jsonHeader));
      localForage.setItem("jsonHeader", jsonHeader);

      localForage
        .setItem("sessionData", sessionData)
        .then(() => {
          this.encryptCookies(sessionData, "cacheData");
          //this.startPushMessagesTimeout();
        })
        .catch((err) => { });
    } else {
      this.setState({ loggedOut: true });
    }
    this.setState({ apiActive: true });
    this.createSession();
  }
  encryptCookies(sessionData, cacheData) {
    let decryptHeader = {
      headers: {
        "content-type": "application/json",
        source: "PWA",
      },
    };
    let sessionParams = {
      flag: 4,
      KeyAndValueList: [
        {
          key: "VCUserContentID",
          value: sessionData.VCUserContentID ? sessionData.VCUserContentID : "",
        },
        {
          key: "VCUserBusinessIds",
          value: sessionData.VCUserBusinessIds
            ? sessionData.VCUserBusinessIds.toString()
            : "",
        },
        {
          key: "VCUserBusinessNames",
          value: sessionData.VCUserBusinessNames
            ? sessionData.VCUserBusinessNames.toString()
            : "",
        },
        {
          key: "VCCountry",
          value: sessionData.VCCountry ? sessionData.VCCountry.toString() : "",
        },
        {
          key: "VCLoginID",
          value: sessionData.VCLoginID ? sessionData.VCLoginID : "",
        },
        {
          key: "VCUserName",
          value: sessionData.VCUserName ? sessionData.VCUserName : "",
        },
        {
          key: "VCUserPhoto",
          value: sessionData.VCUserPhoto ? sessionData.VCUserPhoto : "",
        },
        {
          key: "VCUserPhone",
          value: sessionData.VCUserPhone ? sessionData.VCUserPhone : "",
        },

        {
          key: "VCUserToken",
          value: sessionData.VCUserToken ? sessionData.VCUserToken : "",
        },
        {
          key: "VCAgent",
          value: sessionData.isAgent || "",
        },
        {
          key: "VCFinance",
          value: sessionData.isFinance || "",
        },
      ],
    };
    axios
      .post(
        `${host_url}OnBoarding/EncryptAndDecryptString`,
        sessionParams,
        decryptHeader
      )
      .then((response) => {
        if (response.data.StatusCode === 1) {
          const result = response.data.Result;
          this.setState({ apiActive: true });
          let d = new Date();
          d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * 500);
          result.forEach((data) => {
            if (data.key === "VCUserContentID") {
              document.cookie = `${"vci"}=${data.value
                };domain=${domain_name};path=/;expires=${d.toGMTString()}`;
            }
            if (data.key === "VCUserBusinessIds") {
              document.cookie = `${"vcb"}=${data.value
                };domain=${domain_name};path=/;expires=${d.toGMTString()}`;
            }
            if (data.key === "VCUserBusinessNames") {
              document.cookie = `${"vcn"}=${data.value
                };domain=${domain_name};path=/;expires=${d.toGMTString()}`;
            }
            if (data.key === "VCCountry") {
              document.cookie = `${"vcc"}=${data.value
                };domain=${domain_name};path=/;expires=${d.toGMTString()}`;
            }
            if (data.key === "VCLoginID") {
              document.cookie = `${"vli"}=${data.value
                };domain=${domain_name};path=/;expires=${d.toGMTString()}`;
            }
            if (data.key === "VCUserName") {
              document.cookie = `${"vun"}=${data.value
                };domain=${domain_name};path=/;expires=${d.toGMTString()}`;
            }
            if (data.key === "VCUserPhoto") {
              document.cookie = `${"vup"}=${data.value
                };domain=${domain_name};path=/;expires=${d.toGMTString()}`;
            }
            if (data.key === "VCUserPhone") {
              document.cookie = `${"vcp"}=${data.value
                };domain=${domain_name};path=/;expires=${d.toGMTString()}`;
            }
            if (data.key === "VCUserToken") {
              document.cookie = `${"vti"}=${data.value
                };domain=${domain_name};path=/;expires=${d.toGMTString()}`;
            }
            if (data.key === "VCAgent") {
              document.cookie = `${"vcag"}=${data.value
                };domain=${domain_name};path=/;expires=${d.toGMTString()}`;
            }
            if (data.key === "VCFinance") {
              document.cookie = `${"vcfi"}=${data.value
                };domain=${domain_name};path=/;expires=${d.toGMTString()}`;
            }
            if (data.key === "unk") {
              document.cookie = `${"unk"}=${data.value
                };domain=${domain_name};path=/;expires=${d.toGMTString()}`;
            }
          });
          const urlString = window.location.href;
          const urlQuery = urlString.substring(
            urlString.indexOf("?"),
            urlString.length
          );
          const parsedUrl = queryString.parse(urlQuery);
          if (parsedUrl && parsedUrl.rturl) {
            window.location.href = parsedUrl.rturl;
          } else {
            setTimeout(() => {
              this.setState({ loggedOut: false });
            }, 3000);
            this.createSession(cacheData);
          }

          /*
           */
        } else {
          this.logOut();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  async createSession(cacheData) {
    try {
      let vcbIndex;
      if (cookie.load("vcbIndex")) {
        if (cookie.load("vcbIndex").url !== window.location.hostname) {
          vcbIndex = cookie.load("vcbIndex").id;
          cookie.remove("vcbIndex", {
            path: "/",
            domain: `${domain_name}`,
          });
        } else {
          vcbIndex = 0;
        }
      } else {
        vcbIndex = 0;
      }
      let unk = cookie.load("unk"); //User api token
      // let vcSessionData = cookie.load("vcSessionData");
      let vcSessionData = await localForage.getItem("sessionData");
      let VCUserBusinessIds;
      let VCUserBusinessNames;
      let VCCountry;
      if (vcSessionData) {
        VCUserBusinessIds = vcSessionData.VCUserBusinessIds.toString(); //User Business ids
        VCUserBusinessNames = vcSessionData.VCUserBusinessNames.toString(); //User Business names
        VCCountry = vcSessionData.VCCountry.toString();
      } else {
        VCUserBusinessIds = cookie.load("vcb"); //User Business ids
        VCUserBusinessNames = cookie.load("vcn"); //User Business names
        VCCountry = cookie.load("vcc");
      }
      let VCUserContentID = cookie.load("vci"); //User id
      // let VCCountry = cookie.load("vcc"); //User Business Countries
      let VCLoginID = cookie.load("vli"); //User email
      let VCUserName = cookie.load("vun"); //User Name
      let VCUserPhoto =
        cookie.load("vup") === undefined ? "" : cookie.load("vup"); //User photo
      let VCUserPhone = cookie.load("vcp"); //User Phone
      let VCUserToken = cookie.load("vti"); //User api token
      let VCAgent = cookie.load("vcag"); //agent status
      let VCFinance = cookie.load("vcfi"); //finance status
      let decryptHeader = {
        headers: {
          "content-type": "application/json",
          source: "PWA",
        },
      };
      let sessionParams = {
        flag: 3,
        UniqueId: unk,
        KeyAndValueList: [
          { key: "VCUserContentID", value: VCUserContentID },
          { key: "VCUserBusinessIds", value: VCUserBusinessIds },
          { key: "VCUserBusinessNames", value: VCUserBusinessNames },
          { key: "VCCountry", value: VCCountry },
          { key: "VCLoginID", value: VCLoginID },
          { key: "VCUserName", value: VCUserName },
          { key: "VCUserPhoto", value: VCUserPhoto },
          { key: "VCUserPhone", value: VCUserPhone },
          { key: "VCUserToken", value: VCUserToken },
          { key: "VCAgent", value: VCAgent },
          { key: "VCFinance", value: VCFinance },
        ],
      };

      axios
        .post(
          `${host_url}OnBoarding/EncryptAndDecryptString`,
          sessionParams,
          decryptHeader
        )
        .then((response) => {
          if (response.data.StatusCode === 1) {
            this.setState({ apiActive: true });
            const userIdObject = response.data.Result.find(
              (r) => r.key === "VCUserContentID"
            );
            this.getVirtualAccountDetailsPromise(
              userIdObject ? userIdObject.value : 0
            ).then((virtualAccountResponse) => {
              let SessionData = {
                VCUserContentID: 0,
                VCUserBusinessIds: [],
                VCUserBusinessNames: [],
                VCCountry: [],
                VCLoginID: string,
                VCUserName: string,
                VCUserPhoto: string,
                VCUserPhone: string,
                VCUserToken: string,
              };
              for (
                var index = 0;
                index < response.data.Result.length;
                index++
              ) {
                switch (response.data.Result[index].key) {
                  case "VCUserContentID":
                    SessionData.VCUserContentID =
                      response.data.Result[index].value;
                    break;
                  case "VCUserBusinessIds":
                    let businessIds =
                      response.data.Result[index].value.split(",");
                    let activeBusinessId = businessIds[vcbIndex];
                    if (activeBusinessId) {
                      businessIds.splice(vcbIndex, 1);
                      businessIds.unshift(activeBusinessId);
                    }

                    SessionData.VCUserBusinessIds = businessIds;
                    break;
                  case "VCUserBusinessNames":
                    let businessNames =
                      response.data.Result[index].value.split(",");
                    let activeBusinessName = businessNames[vcbIndex];
                    if (activeBusinessName) {
                      businessNames.splice(vcbIndex, 1);
                      businessNames.unshift(activeBusinessName);
                    }
                    SessionData.VCUserBusinessNames = businessNames;
                    break;
                  case "VCCountry":
                    let countryCodes =
                      response.data.Result[index].value.split(",");
                    let activeCountryCode = countryCodes[vcbIndex];
                    if (activeCountryCode) {
                      countryCodes.splice(vcbIndex, 1);
                      countryCodes.unshift(activeCountryCode);
                    }
                    SessionData.VCCountry = countryCodes;
                    break;
                  case "VCLoginID":
                    SessionData.VCLoginID = response.data.Result[index].value;
                    break;
                  case "VCUserName":
                    SessionData.VCUserName = response.data.Result[index].value;
                    break;
                  case "VCUserPhoto":
                    SessionData.VCUserPhoto = response.data.Result[index].value;
                    break;
                  case "VCUserPhone":
                    SessionData.VCUserPhone = response.data.Result[index].value;
                    break;
                  case "VCUserToken":
                    SessionData.VCUserToken = response.data.Result[index].value;
                    break;
                  case "VCAgent":
                    SessionData.isAgent = response.data.Result[index].value;
                    break;
                  case "VCFinance":
                    SessionData.isFinance = response.data.Result[index].value;
                    break;
                  default:
                }
              }
              SessionData.virtualAccountNumber =
                virtualAccountResponse.data.Result.AccountNumber;
              SessionData.virtualAccountBankName =
                virtualAccountResponse.data.Result.BankName;
              this.setState({ SessionData }, () => {
                //this.addProfileForWebPush();
                //this.addUserBehavior();
                localForage.setItem("sessionData", SessionData).catch((err) => {
                  console.log(err);
                });
                let userId;
                if (
                  vcSessionData &&
                  Number(vcSessionData.VCUserContentID) ===
                  Number(this.state.SessionData.VCUserContentID)
                ) {
                  userId = vcSessionData.VCUserContentID;
                } else {
                  localForage.removeItem("headerData").catch((err) => {
                    console.log(err);
                  });
                  localForage.removeItem("sessionData").catch((err) => {
                    console.log(err);
                  });
                  userId = this.state.SessionData.VCUserContentID;
                }
                let jsonHeader = {
                  headers: {
                    "content-type": "application/json",
                    source: "PWA",
                    Token: this.state.SessionData.VCUserToken,
                    BusinessId: this.state.SessionData.VCUserBusinessIds[0],
                    UserId: userId,
                    countrycode: this.state.SessionData.VCCountry[0],
                  },
                };
                localStorage.setItem("jsonHeader", JSON.stringify(jsonHeader));
                localForage
                  .setItem("jsonHeader", jsonHeader)
                  .then(() => {
                    this.setState({ jsonHeader: jsonHeader }, () => {
                      this.checkHeaderData();
                      //check if request is being made from login, if yes. cache neccessary data
                      // if (cacheData) {
                      // 	this.setState({ fetchingOfflineData: true });

                      // 	setTimeout(() => {
                      // 		//this.loadScripts();
                      // 		//refresh other tabs/windows and login
                      // 		if (channel) {
                      // 			channel.postMessage({
                      // 				action: "login",
                      // 			});
                      // 		}
                      // 	}, 3000);
                      // } else {
                      // 	//this.getAppVersion();
                      // }
                      //this.getCityAndStates();
                    });
                  })
                  .catch((err) => { });
              });
            });
          } else {
            // this.getAppVersion();
            // this.deleteLocalData();
          }
        })
        .catch((error) => {
          // this.getAppVersion();
          // this.deleteLocalData();
        });
    } catch (error) {
      //this.getAppVersion();
    }
  }
  windowLocalStorageClear(flag) {
    if (flag === 1) {
      var cityAndStatesData = localStorage.getItem("cityAndStatesData");
      window.localStorage.clear();
      localStorage.setItem("cityAndStatesData", cityAndStatesData);
    } else {
      window.localStorage.clear();
    }
  }
  setPermissions = () => {
    if (
      this.state.HeaderData &&
      this.state.HeaderData.BusinessId &&
      this.state.HeaderData.BusinessOwnerIdsWithNames &&
      this.state.HeaderData.BusinessOwnerIdsWithNames.length > 0
    ) {
      let activeBusiness = _findArray(
        this.state.HeaderData.BusinessOwnerIdsWithNames,
        "BusinessId",
        this.state.HeaderData.BusinessId
      );
      if (
        activeBusiness &&
        activeBusiness.RolePermissions &&
        activeBusiness.RolePermissions.Permission
      ) {
        let modules = [];
        let subModules = [];
        let features = [];

        let permissions = {};
        let activePermissions = activeBusiness.RolePermissions.Permission;
        let customReports = activePermissions.filter((f) => f.ModuleID === 229);
        let customDashboards = activePermissions.filter(
          (f) => f.ModuleID === 268
        );
        activePermissions.forEach((el) => {
          modules.push(el.ModuleID);
        });
        activePermissions.forEach((el) => {
          subModules.push(el.SubModuleID);
        });
        activePermissions.forEach((el) => {
          features.push(el.FeatureID);
        });

        permissions.modules = _uniqueArray(modules, null, "single");
        permissions.subModules = _uniqueArray(subModules, null, "single");
        permissions.features = _uniqueArray(features, null, "single");
        this.setState({
          showSidebar: true,
          permissions,
          customReports,
          customDashboards,
        });
        return permissions;
      } else {
        let permissions = {
          modules: [],
          subModules: [],
          features: [],
        };
        this.setState({
          showSidebar: true,
          permissions,
          customReports: [],
          customDashboards: [],
        });
      }
    } else {
      let permissions = {
        modules: [],
        subModules: [],
        features: [],
      };
      this.setState({
        showSidebar: true,
        permissions,
        customReports: [],
        customDashboards: [],
      });
    }
  };
  getVirtualAccountDetailsPromise = (userId) => {
    if (userId !== undefined && userId !== null && userId > 0) {
      return axios.get(
        `${host_url}User/GetVirtualAccountDetailsForRetailer?retailerId=${userId}`
      );
    }
  };

  showAlert = (msg, type, header) => {
    if (type === "error") {
      let alertModalDetails = {
        showAlertModal: true,
        showSuccess: false,
        showError: true,
        alertModalSubheader: msg,
        autoClose: true,
        ...(header && { alertModalHeader: header }),
      };
      this.showAlertModal(alertModalDetails);
    } else {
      let alertModalDetails = {
        showAlertModal: true,
        showSuccess: true,
        showError: false,
        alertModalSubheader: msg,
        autoClose: true,
        ...(header && { alertModalHeader: header }),
      };
      this.showAlertModal(alertModalDetails);
    }
  };

  showAlertModal(alertModalDetails) {
    this.setState({ loadAlertModal: true, AlertModal: alertModalDetails });
    let autoClose = alertModalDetails.autoClose;
    if (autoClose !== undefined) {
      if (autoClose === true) {
        setTimeout(() => {
          this.closeAlertModal();
        }, 5000);
      }
    }
  }

  closeAlertModal() {
    let alertModalDetails = {
      showAlertModal: false,
      showSuccess: false,
      showError: false,
      alertModalHeader: "",
      alertModalSubheader: "",
      autoClose: false,
    };

    this.showAlertModal(alertModalDetails);
  }

  hasPermission = (id, type, alertText) => {
    // debugger;
    // prevent non business owner users from doing anything in the app if they haven't started day
    let startDay = true;// cookie.load("currentDay");
    // if (
    //   this.state.HeaderData.UserId &&
    //   this.state.HeaderData.walletAmount &&
    //   this.state.HeaderData.BusinessOwnerIdsWithNames &&
    //   _findArray(
    //     this.state.HeaderData.BusinessOwnerIdsWithNames,
    //     "BusinessId",
    //     Number(this.state.HeaderData.BusinessId)
    //   ) &&
    //   _findArray(
    //     this.state.HeaderData.BusinessOwnerIdsWithNames,
    //     "BusinessId",
    //     Number(this.state.HeaderData.BusinessId)
    //   ).IsBO !== 1
    // ) {
    //   return false;
    // } else {
    if (type === 1) {
      let modules = this.state.permissions.modules;
      if (modules) {
        return modules.includes(id);
        // return false;
      }
      return false;
    } else if (type === 2) {
      let subModules = this.state.permissions.subModules;
      if (subModules) {
        return subModules.includes(id);
        // return false;
      }
      return false;
    } else if (type === 3) {
      let features = this.state.permissions.features;
      if (features) {
        if (features.includes(id)) {
          return true;
        } else {
          if (alertText) {
            this.showAlert(alertText, "error");
          }
          return false;
        }

        // return false;
      } else {
        return false;
      }
    }
  };

  render() {
    //this.checkAutoLogin();
    const role =
      (this.state.HeaderData &&
        this.state.HeaderData.walletAmount &&
        this.state.HeaderData.walletAmount.RoleName) ||
      "";
    return (
      <AppData.Provider
        value={{
          pageTitle: this.state.pageTitle,
          updatePageTitle: this.updatePageTitle,
          HeaderData: this.state.HeaderData,
          getHeaderData: this.getHeaderData,
          walletAmount: this.state.walletAmount,
          BusinessOwnerIdsWithNames: this.state.BusinessOwnerIdsWithNames,
          SessionData: this.state.SessionData,
          jsonHeader: this.state.jsonHeader,
          updateHeaders: this.updateHeaders,
          //clevertapHeader: this.state.clevertapHeader,
          showAlertModal: this.showAlertModal,
          role: role,
          //networkStatus: this.state.networkStatus,
          //pushNotification: this.state.pushNotification,
          //leads: this.state.leads,
          //updateLeads: this.updateLeads,
          //updateWallet: this.updateWallet,
          //getUnaccepted: this.getUnaccepted,
          togglePrompt: this.toggleInstallPrompt,
          //downloadApp: this.downloadApp,
          //logOut: this.logOut,
          //isAppInstalled: this.state.isAppInstalled,
          //Services: this.state.services,
          showDownloadMenu: this.state.showDownloadMenu,
          //showTerms: this.showTerms,
          setCurrency: this.setCurrency,
          //logClevertapEvent: this.logClevertapEvent,
          //rtUrl: this.state.rtUrl,
          //setRtUrl: this.setRtUrl,
          //googleLocationId: this.state.googleLocationId,
          //updateGoogleBusinessDetails: this.updateGoogleBusinessDetails,
          //isGoogleSyncing: this.state.isGoogleSyncing,
          //updateGoogleSyncStatus: this.updateGoogleSyncStatus,
          //facebookDetails: this.state.facebookDetails,
          //updateFacebookDetails: this.updateFacebookDetails,
          //isDemoAccount: true,
          //subscriptionStatus: this.state.subscriptionStatus,
          //isFbSynced: this.state.isFbSynced,
          //isWebsiteSynced: this.state.isWebsiteSynced,
          //getFbBusinessDetails: this.getFbBusinessDetails,
          // isPaid:
          // 	this.state.HeaderData.IsBusinessFree &&
          // 	[1, 3].includes(this.state.HeaderData.IsBusinessFree),
          // subStatus: this.state.HeaderData.IsBusinessFree,
          //publishers: this.state.HeaderData.walletAmount.ActivePlatform,
          //publisherList: this.createPublisherLists(),
          //allBusinesses: this.state.allBusinesses,
          //logButtonClick: this.logButtonClick,
          history: this.props.history,
          location: this.props.location,
          showToast: this.showToast,
          showAlert: this.showAlert,
          userId: Number(this.state.SessionData.VCUserContentID),
          userName: this.state.SessionData.VCUserName,
          businessId: Number(this.state.HeaderData.BusinessId),
          //showOfflineNotif: this.showOfflineNotif,
          //updateManualOffline: this.updateManualOffline,
          //isOffline: this.state.showOfflineStrip,
          //fetchingOfflineData: this.state.fetchingOfflineData,
          permissions: this.state.permissions,
          hasPermission: this.hasPermission,
          //showSidebar: this.state.showSidebar,
          //appVersion: this.state.appVersion,
          //updateAppVersion: this.updateAppVersion,
          //pushMessages: this.state.pushMessages,
          //getPushMessages: this.getPushMessages,
          //updateToursDone: this.updateToursDone,
          //checkIfDoneTour: this.checkIfDoneTour,
          //updatePageData: this.state.updatePageData,
          //updateOfflineData: this.updateOfflineData,
          //checkOfflineRequests: this.checkOfflineRequests,
          userLocation: this.props.userLocation,
          isSettingsActivated: this.isSettingsActivated,
          //businessType: this.state.HeaderData.walletAmount.BusinessType,
          saveToIndexDb: this.saveToIndexDb,
          getBusinessSettings: this.getBusinessSettings,
          contactTypes: this.state.contactTypes,
          getContactTypes: this.getContactTypes,
          getFromIndexDb: this.getFromIndexDb,
          //connectionStatus: this.state.connectionStatus,
          //pendingRequests: this.state.pendingRequests,
          //updatePendingRequests: this.updatePendingRequests,
          isOmsBusiness: true,
          cacheId: `${this.state.HeaderData.UserId}-${this.state.HeaderData.BusinessId}`,
          //customReports: this.state.customReports,
          //customDashboards: this.state.customDashboards,
          getUserAddress: this.props.getUserAddress,
          geolocationStatus: this.props.geolocationStatus,
          getUserCoordinates: this.props.getUserCoordinates,
          //isAgent: this.state.HeaderData.walletAmount.IsEndUser !== 0,
          getMeetingState: this.getMeetingState,
          // isPageVisible: this.props.isPageVisible,
          // toggleSidebar: this.toggleSidebar,
          // disableSendbirdSet: this.disableSendbirdSet,
          // disableSendbird: this.state.disableSendbird,
          // forceAppVersionUpdate: this.forceAppVersionUpdate,
        }}
      >
        
        { (this.state.apiActive === true && this.state.businessId > 0 && this.state.history > 0)
            ? <div className="App">
              <BusinessHome userId={this.state.userId}/>
            </div>
            : (this.state.apiActive === true && this.state.businessId > 0 && this.state.reconcilliation > 0) ? (
          <div className="App">
            <PmDriverReconciliation
              businessId={this.state.businessId}
            />
          </div>
        ) : (this.state.apiActive === true && this.state.businessId > 0 && this.state.orderId > 0)
          ? (
            <div className="App">
              <OrderProcessing businessId={this.state.businessId} orderId={this.state.orderId} processtype={this.state.processtype}/>
              {/* <Shipments businessId={this.state.businessId} /> */}
            </div>
          ) : (
            <div style={{ textAlign: "center", paddingTop: "200px", fontWeight: "800", fontSize: "20"}}>
              
               {this.state.businessId === 0 ? (
                <Loader
                errorText="BusinessId parameter not passed"
                />
              ) : this.state.orderId === 0 ? (
                <Loader
                errorText="OrderId parameter not passed"
                />
              ): 
              <div>
              <Loader
              margin={"50px auto 150px"}
              size={"4px"}
              />
              {"Some thing went wrong--"}
              <div style={{paddingTop:"20px",textAlign: "left",paddingLeft:"10px"}}>
              {/* {JSON.stringify(this.state.urlDataNew)} */}
              <p>URL:- {this.state.urlDataNew.length > 0 ?this.state.urlDataNew[0] :""}</p>
              <p>&BusinessId:- {this.state.urlDataNew.length > 1 ?this.state.urlDataNew[1] :""}</p>
              <p>&OrderId:- {this.state.urlDataNew.length > 2 ?this.state.urlDataNew[2] :""}</p>
                </div>
              </div>
              }
              
              {/* <Loader/> */}
            </div>
          )}
        {this.state.loadAlertModal && (
          <AlertModal
            showAlertModal={this.state.AlertModal.showAlertModal}
            showSuccess={this.state.AlertModal.showSuccess}
            showError={this.state.AlertModal.showError}
            alertModalHeader={this.state.AlertModal.alertModalHeader}
            alertModalSubheader={
              this.state.AlertModal.alertModalSubheader
            }
          />
        )}
      </AppData.Provider>
    );
  }
}

// function App() {
//   debugger;
//   return (
//     <div>
//       <PmDriverReconciliation />
//     </div>
//   );
// }

export default withAppData(App);
